import { configureStore } from "@reduxjs/toolkit";

//--------------------- admin --------------------
import { authSlice } from "./slices/admin/session/auth";
import { meSlice } from "./slices/admin/me.slice.js";
import { settingsSlice } from "./slices/admin/settings/settings.slice";
import { toastSlice } from "./slices/common/toast.slice";
import { adminModalSlice } from "./slices/common/adminModal.slice";
import { cmsSlice } from "./slices/admin/cms";
import { reportProblemSlice } from "./slices/admin/reportProblem";
import { rolesSlice } from "./slices/admin/membersAndRoles/roles";
import { accessSlice } from "./slices/admin/membersAndRoles/permission";
import { accessUsersSlice } from "./slices/admin/membersAndRoles/teamMembers";
import { dashboardSlice } from "./slices/admin/dashboard";
import { languagesSlice } from "./slices/admin/dataManagement/language";
import { rejectReasonSlice } from "./slices/admin/dataManagement/rejectReason";
import { countrySlice } from "./slices/admin/dataManagement/country";
import { colorSlice } from "./slices/admin/dataManagement/color";
import { holidaySlice } from "./slices/admin/dataManagement/holiday";
import { usersSlice } from "./slices/admin/users";
import { sequrityQuestionSlice } from "./slices/admin/sequrityQuestion";
import { reviewsSlice } from "./slices/admin/reviews";
import { reportCategoriesSlice } from "./slices/admin/dataManagement/reportCategory";
import { userPlanSlice } from "./slices/admin/dataManagement/UserPlan";
import { feedbackSlice } from "./slices/admin/feedback";
import { helpAndFeedbackSlice } from "./slices/admin/dataManagement/helpAndFeedback";
import { fullScreenMediaSlice } from "./slices/common/fullScreenMedia.slice";
import { timezoneSlice } from "./slices/admin/dataManagement/timezone";
import { emojiSlice } from "./slices/admin/dataManagement/emoji";
import { appUrlSlice } from "./slices/admin/dataManagement/getTheApps";
function configStore() {
  const store = configureStore({
    reducer: {
      auth: authSlice.reducer,
      me: meSlice.reducer,
      dashboard: dashboardSlice.reducer,
      settings: settingsSlice.reducer,
      toast: toastSlice.reducer,
      adminModal: adminModalSlice.reducer,
      cms: cmsSlice.reducer,
      reportProblem: reportProblemSlice.reducer,
      roles: rolesSlice.reducer,
      access: accessSlice.reducer,
      accessUsers: accessUsersSlice.reducer,
      languages: languagesSlice.reducer,
      rejectReasons: rejectReasonSlice.reducer,
      country: countrySlice.reducer,
      color: colorSlice.reducer,
      reviews: reviewsSlice.reducer,
      users: usersSlice.reducer,
      sequrityQuestion: sequrityQuestionSlice.reducer,
      holiday: holidaySlice.reducer,
      reportCategory: reportCategoriesSlice.reducer,
      userPlan: userPlanSlice.reducer,
      appUrl:appUrlSlice.reducer,
      feedback: feedbackSlice.reducer,
      helpAndFeedback: helpAndFeedbackSlice.reducer,
      fullScreenMedia: fullScreenMediaSlice.reducer,
      timezone: timezoneSlice.reducer,
      emoji: emojiSlice.reducer,
      // Add other reducers if needed
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }),
  });
  return store;
}

export default configStore;
